import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Send, Building } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Mail size={32} />,
      title: 'Email',
      value: 'nelsonm@iitpkd.ac.in',
      link: 'mailto:nelsonm@iitpkd.ac.in',
      color: 'from-blue-600 to-cyan-500',
      bgColor: 'bg-gradient-to-br from-blue-50 to-cyan-50',
    },
    {
      icon: <Phone size={32} />,
      title: 'Phone',
      value: '0491 209 1464',
      link: 'tel:+914912091464',
      color: 'from-cyan-500 to-purple-500',
      bgColor: 'bg-gradient-to-br from-cyan-50 to-purple-50',
    },
    {
      icon: <MapPin size={32} />,
      title: 'Office',
      value: 'Mechanical Engineering Department',
      secondary: 'Indian Institute of Technology Palakkad',
      tertiary: 'Palakkad, Kerala, India',
      color: 'from-purple-500 to-pink-500',
      bgColor: 'bg-gradient-to-br from-purple-50 to-pink-50',
    },
  ];

  return (
    <section id="contact" className="section-container bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200 to-purple-200 rounded-full filter blur-3xl opacity-20 animate-float"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-cyan-200 to-pink-200 rounded-full filter blur-3xl opacity-20 animate-float" style={{ animationDelay: '1.5s' }}></div>
      
      <h2 className="section-title">Contact Information</h2>
      
      <div className="w-full relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {contactInfo.map((info, index) => (
            <Card key={index} className="border-2 border-transparent hover:border-blue-200 overflow-hidden group hover-lift interactive-card">
              <div className={`h-2 bg-gradient-to-r ${info.color}`}></div>
              <CardContent className={`p-8 text-center ${info.bgColor} relative`}>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-50 transition-opacity duration-500"></div>
                <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${info.color} rounded-2xl text-white mb-4 shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-500 relative z-10`}>
                  {info.icon}
                </div>
                <h3 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3 relative z-10">{info.title}</h3>
                {info.link ? (
                  <a
                    href={info.link}
                    className="text-slate-700 hover:text-blue-600 transition-colors font-semibold block mb-1 relative z-10"
                  >
                    {info.value}
                  </a>
                ) : (
                  <p className="text-slate-700 font-semibold mb-1 relative z-10">{info.value}</p>
                )}
                {info.secondary && (
                  <p className="text-slate-600 text-sm relative z-10">{info.secondary}</p>
                )}
                {info.tertiary && (
                  <p className="text-slate-600 text-sm relative z-10">{info.tertiary}</p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 rounded-3xl p-12 text-center shadow-2xl relative overflow-hidden">
          {/* Animated background elements */}
          <div className="absolute top-0 left-0 w-40 h-40 bg-white rounded-full filter blur-3xl opacity-10 animate-float"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-cyan-300 rounded-full filter blur-3xl opacity-20 animate-float" style={{ animationDelay: '1s' }}></div>
          
          <div className="flex items-center justify-center gap-3 mb-4 relative z-10">
            <Building size={40} className="text-white" />
            <h3 className="text-4xl font-bold text-white">
              Interested in Collaboration?
            </h3>
          </div>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed relative z-10">
            I welcome opportunities for research collaboration, consultancy projects, and academic partnerships. 
            Feel free to reach out for potential collaborations or inquiries.
          </p>
          <div className="flex flex-wrap gap-4 justify-center relative z-10">
            <Button
              asChild
              className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-6 text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 font-bold"
            >
              <a href="mailto:nelsonm@iitpkd.ac.in">
                <Send size={20} className="mr-2" />
                Send Email
              </a>
            </Button>
            <Button
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-6 text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 font-bold"
            >
              <Linkedin size={20} className="mr-2" />
              LinkedIn Profile
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;